import { Avatar, Box, CircularProgress } from "@mui/material";
import { useState } from "react";

export default function IntegrationLogo  ({ name, logo_url, size = 40 }) {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  // Função para obter as iniciais do nome
  const getInitials = (name) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {loading && <CircularProgress size={20} sx={{ position: 'absolute' }} />}
      
      {error ? (
        <Avatar sx={{ 
          width: size, 
          height: size, 
          bgcolor: '#1976d2',
          fontSize: size / 2
        }}>
          {getInitials(name)}
        </Avatar>
      ) : (
        <img 
          src={logo_url} 
          alt={`Logo ${name}`} 
          style={{ 
            width: size, 
            height: size, 
            objectFit: 'contain',
            display: loading ? 'none' : 'block',
            borderRadius: '4px'
          }}
          onLoad={() => setLoading(false)}
          onError={() => {
            setError(true);
            setLoading(false);
          }}
        />
      )}
    </Box>
  );
};